import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { routes } from "./routes";
import BlankLayout from "../layout/BlankLayout";

const finalRoutes = routes.map((route) => ({
  ...route,
  element: <BlankLayout>{route.element}</BlankLayout>,
}));

const router = createBrowserRouter(finalRoutes, {
  basename: process.env.REACT_APP_HOME_PAGE_URL,
});

export default router;
